import type { LivenessStage } from "./SessionUIController/types";

export function getLivenessProgressPercent(
  actionState: LivenessStage | null | undefined,
  hasIdentification: boolean,
): { pct: number; showBar: boolean; showAlmostDone: boolean } {
  const s = actionState ?? "front";
  if (!hasIdentification) {
    if (s === "selfie" || s === "selfie-captured") {
      return { pct: s === "selfie" ? 50 : 90, showBar: false, showAlmostDone: true };
    }
    return { pct: 0, showBar: false, showAlmostDone: false };
  }
  switch (s) {
    case "front":
      return { pct: 20, showBar: true, showAlmostDone: false };
    case "front-captured":
      return { pct: 33, showBar: true, showAlmostDone: false };
    case "back":
      return { pct: 50, showBar: true, showAlmostDone: false };
    case "back-captured":
      return { pct: 66, showBar: true, showAlmostDone: false };
    case "selfie":
      return { pct: 80, showBar: true, showAlmostDone: true };
    case "selfie-captured":
      return { pct: 95, showBar: true, showAlmostDone: true };
    default:
      return { pct: 0, showBar: false, showAlmostDone: false };
  }
}
